import React from 'react';

const IntegratoriIcon = (props) => {
  const fill = props ? props.color : '#294C76';
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3663 14.179L12.8782 13.6671C13.794 12.7513 15.3098 12.7822 16.2638 13.7362C17.2178 14.6902 17.2487 16.206 16.3329 17.1218L15.821 17.6338C15.7778 17.5242 15.7227 17.3974 15.6527 17.2566C15.4264 16.8018 15.0463 16.2044 14.421 15.5791C13.7957 14.9537 13.1982 14.5736 12.7434 14.3473C12.6026 14.2773 12.4758 14.2221 12.3663 14.179Z"
        fill={fill}
      />
      <path
        d="M11.1401 15.4052L10.6671 15.8782C9.75131 16.794 9.78224 18.3098 10.7362 19.2638C11.6902 20.2178 13.206 20.2487 14.1218 19.3329L14.5947 18.86L14.495 18.3902L14.4921 18.3789C14.4879 18.3637 14.4797 18.335 14.4661 18.2947C14.4388 18.2139 14.3901 18.0864 14.3097 17.9247C14.1492 17.602 13.861 17.1404 13.3603 16.6397C12.8597 16.139 12.398 15.8508 12.0753 15.6903C11.9135 15.6098 11.7859 15.5611 11.7052 15.5338C11.6648 15.5202 11.6362 15.5119 11.6209 15.5078L11.6096 15.5048L11.1401 15.4052Z"
        fill={fill}
      />
      <path
        d="M2.07612 0.617317C2 0.801088 2 1.03406 2 1.5C2 1.96594 2 2.19891 2.07612 2.38268C2.17761 2.62771 2.37229 2.82239 2.61732 2.92388C2.80109 3 3.03406 3 3.5 3H5H11H12.5C12.9659 3 13.1989 3 13.3827 2.92388C13.6277 2.82239 13.8224 2.62771 13.9239 2.38268C14 2.19891 14 1.96594 14 1.5C14 1.03406 14 0.801088 13.9239 0.617317C13.8224 0.372288 13.6277 0.177614 13.3827 0.0761205C13.1989 0 12.9659 0 12.5 0H3.5C3.03406 0 2.80109 0 2.61732 0.0761205C2.37229 0.177614 2.17761 0.372288 2.07612 0.617317Z"
        fill={fill}
      />
      <path
        d="M3.74997 4L1.50122 5.79896C1.00902 6.19272 0.623508 6.69147 0.366442 7.24994H15.6401C15.3862 6.69266 15.0046 6.19417 14.5168 5.79925L12.2942 4H3.74997Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 8.90822C16 8.85533 15.999 8.80256 15.9969 8.74994H0.00371446C0.0012437 8.80726 0 8.86478 0 8.92244V15.2499H9.23399C9.34523 15.0993 9.4694 14.9547 9.60668 14.8174L11.8177 12.6064C12.9608 11.4634 14.6118 11.2295 16 11.7954V8.90822ZM8.75 11.2499V9.99994C8.75 9.58572 8.41421 9.24994 8 9.24994C7.58579 9.24994 7.25 9.58572 7.25 9.99994V11.2499H6C5.58579 11.2499 5.25 11.5857 5.25 11.9999C5.25 12.4141 5.58579 12.7499 6 12.7499H7.25V13.9999C7.25 14.4141 7.58579 14.7499 8 14.7499C8.41421 14.7499 8.75 14.4141 8.75 13.9999V12.7499H10C10.4142 12.7499 10.75 12.4141 10.75 11.9999C10.75 11.5857 10.4142 11.2499 10 11.2499H8.75Z"
        fill={fill}
      />
      <path
        d="M8.57286 16.7499C8.35133 17.8711 8.63863 19.0722 9.38462 19.9999H4.95693C4.38582 19.9999 4.10026 19.9999 3.82957 19.9628C3.02661 19.8526 2.27608 19.501 1.67738 18.9548C1.47554 18.7706 1.29272 18.5512 0.927115 18.1125C0.590204 17.7082 0.339006 17.2447 0.183677 16.7499H8.57286Z"
        fill={fill}
      />
    </svg>
  );
};

export default IntegratoriIcon;
